const INITIAL_STATE = {
  extractHistory: {points: ''},
  challenges: [],
  challenge: {},
  situation: 'ALL',
  filterDate: {
    begin: '',
    end: ''
  },

  storeClassification: null,
  pendencies: {
    hasPendencies: false,
    storesSelected: [],
    rules: { 
      s5: true 
    }
  },
  storesLapidar: [],
  storesToAdd: [],
  selectedStoreLapidar: null,
  hasClassification: false,
  programClose: false,
  pendenciesOn: false,
  backToMap: false,
  historic: null,
  slides: null
};

export default function classificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_STORE_EXTRACT":
      return {
        ...state,
        extractHistory: action.extractHistory
      };
    case 'SET_CHALLENGES_EXTRACT':
      return {
        ...state,
        challenges: action.challenges
      }
    case 'CHALLENGE_SELECTED_EXTRACT':
      return {
        ...state,
        challenge: action.challenge
      }
    case 'SET_DATE_EXTRACT': 
      return {
        ...state,
        filterDate: {
          begin: action.begin, 
          end: action.end
        }
      }
    case 'CHANGE_SITUATION_EXTRACT': 
      return {
        ...state,
        situation: action.situation
      }
    case "SET_STORE_CLASSIFICATION":
      return {
        ...state,
        storeClassification: action.storeClassification
      };
    case "SET_PENDENCIES":
      return {
        ...state,
        pendencies: action.pendencies
      };
    case "SET_STORES_LAPIDAR":
      return {
        ...state,
        storesLapidar: action.storesLapidar
      };
    case "SET_STORES_LAPIDAR_ADD":
      return {
        ...state,
        storesToAdd: action.storesToAdd
      };
    case "SELECTED_STORE_LAPIDAR":
      return {
        ...state,
        selectedStoreLapidar: action.selectedStoreLapidar
      };
    case "SET_HASCLASSIFICATION":
      return {
        ...state,
        hasClassification: action.hasClassification
      };
    case "SET_PROGRAM_CLOSE":
      return {
        ...state,
        programClose: action.programClose
      };
    case "SET_BACKTOMAP":
      return {
        ...state,
        backToMap: !state.backToMap
      };
    case "SET_PENDENCIESON":
      return {
        ...state,
        pendenciesOn: action.pendenciesOn
      };
    case "SET_HISTORIC":
      return {
        ...state,
        historic: action.historic
      };
    case "SET_SLIDES":
      return {
        ...state,
        slides: action.slides
      };
    default:
      return state;
  }
}
